import React, { useState } from "react";
import { Box, Button, useTheme } from "@mui/material";
import CustomTypography from "../common/form/CustomTypography";
import {
  CheckCircle as CheckCircleIcon,
  ExitToApp as ExitIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useStores } from "../../../use-stores";

interface SwagstoreHeaderProps {
  onPreviewStore?: () => void;
  onPublishStore?: () => void;
  onExit?: () => void;
  lastSavedTime?: string;
}

const SwagstoreHeader: React.FC<SwagstoreHeaderProps> = ({
  onPreviewStore,
  onPublishStore,
  onExit,
  lastSavedTime = "just now",
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { swagStoreStore } = useStores();
  const [savedTime, setSavedTime] = useState(lastSavedTime);

  const handleExit = () => {
    // Clear all store data before exiting
    swagStoreStore.resetStore();
    
    if (onExit) {
      navigate("/swagstore/listing");
      onExit();
    } else {
      navigate("/swagstore/listing");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 2,
        backgroundColor: theme.palette.customColors?.white || "#FFFFFF",
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      <CustomTypography
        variant="heading5"
        fontWeight={700}
        sx={{ color: theme.palette.customColors?.blackText || "#000000" }}
      >
        Customize Swag Store
      </CustomTypography>

      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        {/* Saved Status */}
        {/* <Button
          variant="outlined"
          startIcon={<CheckCircleIcon sx={{ color: theme.palette.customColors.successGreen }} />}
          sx={{
            borderRadius: "8px",
            borderColor: theme.palette.customColors.successGreenLightBorder,
            backgroundColor: theme.palette.customColors.successGreenLightBackground,
            color: theme.palette.customColors.successGreen,
            textTransform: "none",
            fontWeight: 500,
            px: 2,
            py: 1,
            "&:hover": {
              borderColor: theme.palette.customColors.successGreenLightBorder,
              backgroundColor: theme.palette.customColors.successGreenLightBackground,
            },
          }}
        >
          Saved {savedTime}
        </Button> */}

        {/* Preview Store Button */}
        <Button
          variant="outlined"
          onClick={onPreviewStore}
          sx={{
            borderRadius: "8px",
            borderColor: theme.palette.divider,
            color: theme.palette.customColors?.greyTextColor || "#6B7280",
            textTransform: "none",
            fontWeight: 500,
            px: 2,
            py: 1,
            "&:hover": {
              borderColor: theme.palette.divider,
              backgroundColor: theme.palette.action?.hover,
            },
          }}
        >
          Preview Store
        </Button>

        {/* Publish Store Button */}
        {/* <Button
          variant="contained"
          onClick={onPublishStore}
          sx={{
            borderRadius: "8px",
            backgroundColor: theme.palette.customColors?.purple || "#8B5CF6",
            color: theme.palette.customColors.white,
            textTransform: "none",
            fontWeight: 600,
            px: 2,
            py: 1,
            "&:hover": {
              backgroundColor: theme.palette.customColors?.purpleDark || theme.palette.customColors?.purple,
            },
          }}
        >
          Publish Store
        </Button> */}

        {/* Exit Button */}
        <Button
          variant="outlined"
          onClick={handleExit}
          endIcon={<ArrowForwardIcon />}
          sx={{
            borderRadius: "8px",
            borderColor: theme.palette.divider,
            color: theme.palette.customColors?.greyTextColor || "#6B7280",
            textTransform: "none",
            fontWeight: 500,
            px: 2,
            py: 1,
            "&:hover": {
              borderColor: theme.palette.divider,
              backgroundColor: theme.palette.action?.hover,
            },
          }}
        >
          Exit
        </Button>
      </Box>
    </Box>
  );
};

export default SwagstoreHeader;
